module.exports = "/static/assets/35c6867250ec4f430624bc9e2e7072d7.svg";